import { ForwardedRef, forwardRef } from "react";

// Custom styles for MDInput
import MDInputRoot from "../MDInput/MDInputRoot";
import { BaseProps } from "@mui/material/OverridableComponent";

export const MDInput = forwardRef(({ 
  error = false, 
  success = false, 
  disabled = false, 
  ...rest 
}: BaseProps<any>, ref: ForwardedRef<any>) => (
  <MDInputRoot {...rest} ref={ref} ownerState={{ error, success, disabled }} />
));
